import React from 'react';
import classnames from 'classnames';
import { goldThicknessOptions } from 'shared/data/selectOptions';
import SelectComponent from 'shared/components/SelectComponent';

const GoldThickness = (props) => {
  const name = 'gold_thickness';

  const {
    onChangeParameter,
    label,
    required,
    options,
    tooltip,
    parameters,
    groupName,
    className,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <SelectComponent
      label={label}
      required={required}
      name={name}
      onChange={onChange}
      options={options}
      tooltip={tooltip}
      selected={parameters[name]}
      groupName={groupName}
      className={classnames('gold-thickness', className)}
      disabled={disabled} />
  );
};

GoldThickness.defaultProps = {
  label: Spree.translations.parameters.gold_thickness,
  options: goldThicknessOptions,
  tooltip: Spree.helpForParameters.gold_thickness,
};

export default GoldThickness;
